import { Form } from 'formik'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { NumberFieldInput } from '@dhl/inputs'
import { TextFieldInput } from '@dhl/formik'
import { Box, Button, Card, Grid, H6 } from '@dhl-ui/components'
import { links } from '~/AppRoutes'

export const BillingunitForm = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Card>
      <Card.Header title={t('admin.billingUnitsPage.titleText')} />
      <Card.Content>
        <Box pb={2}>
          <H6>{t('admin.billingUnitsPage.billingUnitsForm.account')}</H6>
        </Box>

        <Form data-testid="billingunit-form">
          <Grid container spacing={2} direction="column">
            <TextFieldInput name="cccId" label={t('admin.billingUnitsPage.billingUnitsForm.identifier')} disabled />
            <TextFieldInput name="name" label={t('admin.billingUnitsPage.billingUnitsForm.name')} disabled />
            <TextFieldInput
              name="description"
              label={t('admin.billingUnitsPage.billingUnitsForm.description')}
              fullWidth
              disabled
            />
          </Grid>
          <Box pt={3} pb={2}>
            <H6>{t('admin.billingUnitsPage.billingUnitsForm.labelCodeRange')}</H6>
          </Box>
          <Grid container spacing={2}>
            <Grid size={{ xs: 4 }}>
              <NumberFieldInput
                name="trackerCodeMin"
                label={t('admin.billingUnitsPage.billingUnitsForm.trackerCodeMin')}
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 4 }}>
              <NumberFieldInput
                name="trackerCodeMax"
                label={t('admin.billingUnitsPage.billingUnitsForm.trackerCodeMax')}
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 4 }}>
              <NumberFieldInput
                name="trackerCodeLast"
                label={t('admin.billingUnitsPage.billingUnitsForm.trackerCodeLast')}
                fullWidth
                disabled={true}
              />
            </Grid>
          </Grid>
          <Box pt={2} flexGrow={1} display="flex" justifyContent="flex-end">
            <Box mr={2}>
              <Button
                color="primary"
                type="submit"
                variant="text"
                size="medium"
                onClick={() => navigate(links.billingUnitsLink())}
              >
                {t('admin.billingUnitsPage.billingUnitsForm.cancelButtonTitle')}
              </Button>
            </Box>
            <Button variant="contained" data-testid="submit-billingunit" color="primary" size="medium" type="submit">
              {t('admin.billingUnitsPage.billingUnitsOverview.updateBillingunitButtonTitle')}
            </Button>
          </Box>
        </Form>
      </Card.Content>
    </Card>
  )
}
